import { FC, Fragment, useEffect, useState } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { FormObjSwitch } from "Utils/SwitchCases";
import CommonFormatter from "Utils/Common.Formatter";
import { FormObjType } from "DataTypes/Form";
import { VaccineForm } from "./Data";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import CstmBtn from "Components/CstmBtn";
import { DataActionType } from ".";

interface AddEditViewModalProps {
  onClose: () => void;
  refreshList: () => void;
  dataAction: DataActionType
}

const UpdateVaccine: FC<AddEditViewModalProps> = (props) => {
  const { dataAction, onClose, refreshList } = props;
  const isEdit = dataAction.action == "EDIT";
  const isView = dataAction.action == "VIEW";
  const [formData, setFormData] =
    useState<FormObjType[]>(JSON.parse(JSON.stringify(VaccineForm)));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    handleLoadData();
  }, [dataAction.data?.id, dataAction.action]);

  const handleLoadData: () => void = () => {
    let newFormData: FormObjType[] = JSON.parse(JSON.stringify(VaccineForm));
    if (isEdit || isView) {
      newFormData[0].inputVal = dataAction?.data?.name;
      newFormData[1].inputVal = dataAction?.data?.dateTime;
      newFormData[2].inputVal = dataAction?.data?.routeName;
      newFormData[3].inputVal = dataAction?.data?.dose;
      newFormData[4].inputVal = dataAction?.data?.doseUnit;
    }
    if (isView) {
      newFormData = newFormData.map(el => ({ ...el, readOnly: true }));
    }
    setFormData(newFormData);
  }

  const handleSave: () => void = () => {
    setLoading(true);
    !isEdit && setFormData([...VaccineForm]);
    refreshList();
    onClose();
    setLoading(false);
  };

  return (
    <Fragment>
      <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
        <Typography fontWeight="bold" textTransform="capitalize">
          {dataAction.action?.toString().toLowerCase()} Vaccine
        </Typography>
        <Box display={"flex"} alignItems={"center"}>
          <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={onClose}
          >
            <ImgPath.CloseIcon titleAccess="Close" />
          </Box>
        </Box>
      </Box>
      <Box sx={{ ...sxMain }}>
        <Grid container rowSpacing={1} columnSpacing={2}>
          {formData.map((el) => {
            return (
              <Grid key={el.id} item {...{ md: 4, lg: 3, xl: 3 }}>
                {FormObjSwitch({
                  formObj: el,
                  inputChange: async (props) => {
                    setFormData(
                      CommonFormatter.HandleInputChange(props, formData)
                    );
                  },
                  onClick: async (props) => {
                    setFormData(
                      CommonFormatter.HandleClickChange(props, formData)
                    );
                  }

                })}
              </Grid>
            );
          })}
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Box
          display="flex"
          justifyContent={"flex-end"}
          sx={{ "&>button": { ml: 1 } }}
        >
          {!isView && (
            <CstmBtn
              label={loading ? "Loading..." : "Save"}
              onClick={handleSave}
              disable={loading}
            />
          )}
          <CstmBtn label={"Close"} onClick={onClose} btnType="border" />
        </Box>
      </Box>
    </Fragment>
  );
};

export default UpdateVaccine;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "85%",
  overflow: "auto",
  px: 2,
};
